import axios from "axios";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { Button, Loader, Placeholder } from "rsuite";
import PagePreviousIcon from "@rsuite/icons/PagePrevious";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";

import AuthService from "../../../services/auth.service";

import CalendarOrange from "../../../img/calendar-oragnge.svg";

import "./dashboard.scss";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const Dashboards = (props) => {
  const [, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [hasWeighing, setHasWeighing] = useState(true);

  useEffect(() => {
    sync();
    setHasWeighing(!AuthService.getSubscription().is_user_form_update);
  }, []);

  const splitStatusLabel =
    AuthService.getUser().subscription?.status_label.split("(");

  return (
    <>
      <div className="dashboard-container">
        {!AuthService.getUser().subscription.is_expired ? (
          <div className="grid--col-2 ">
            <div className="d-flex btn-valid-subscription">
              <div className="btn-icon">
                <img
                  src={CalendarOrange}
                  style={{ width: "25px" }}
                  alt="calender"
                />
              </div>

              {AuthService.getUser().subscription.processing ? (
                <div className="text-loading flex items-center flex-wrap gap-1">
                  <span>{splitStatusLabel[0]}</span>
                  <span>
                    {"(" + splitStatusLabel[1]} <ArrowLeftLineIcon />
                  </span>
                </div>
              ) : (
                <div className="btn-content">
                  تا اتمام رژیم شما:
                  <div className="text-bold">
                    {AuthService.getUser().subscription.days} روز مانده
                  </div>
                </div>
              )}
            </div>

            <div>
              {hasWeighing || AuthService.getUser().subscription.processing ? (
                ""
              ) : (
                <Button
                  color="blue"
                  onClick={(e) =>
                    (window.location.href = AuthService.getUser().subscription
                      .processing
                      ? "/subscriptions"
                      : "/subscriptions/active-subscription")
                  }
                  appearance="primary"
                  className="btn-expanded btn-header"
                  endIcon={<PagePreviousIcon color="#fff" />}
                >
                  مشاهده رژیم
                </Button>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="card-shadow ">
          <div className="d-flex card-align">
            <div
              className="w-50 text-bold text-start"
              style={{
                fontSize: ".8rem",
                textAlign: "start",
                marginTop: "1.5rem",
              }}
            >
              وضعیت جسمی
            </div>
          </div>

          <div className="cards-container ">
            {data ? (
              render()
            ) : (
              <div>
                <Placeholder.Paragraph rows={5} />
                <Loader
                  backdrop
                  content="درحال خواندن اطلاعات شما ..."
                  vertical
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  function render() {
    return (
      <div className="cards">
        {data.cards.map((card, cardIndex) => {
          return (
            <div key={cardIndex} className="card-container">
              <div className="card">
                <img
                  src={card.image}
                  className="card-svg-icon"
                  alt={card.title}
                />
                <div className="title">{card.title}</div>
                <div className="value">
                  <div className="content">{card.value}</div>
                  <div className="unit">{card.unit}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  function sync() {
    let config = {
      headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
    };

    setIsLoading(true);

    axios
      .get(`${APP_URL}/api/v6/dashboards`, config)
      .then(function (response) {
        setData(response.data.data);
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();

          return false;
        }

        const statusCode = error.response.status;
        switch (statusCode) {
          case 422:
            const { errors } = error.response.data;

            for (const errorsKey in errors) {
              const error = errors[errorsKey];

              toast.error(error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            break;

          case 401:
            AuthService.logout();
            window.location.replace("/");
            break;
          default:
            handleNotfound();

            break;
        }
      });
  }

  function handleNotfound() {
    localStorage.setItem("error", "PageNotFound");
    setIsLoading(false);
    window.location.href = "";
  }
};
export default Dashboards;
